<template>
  <div :class="{'absolute-wrapper': absoluteMode}">
    <div class="custom-table">
      <vue-perfect-scrollbar><!-- instead of "responsive" for b-table -->
        <b-table :dark="darkMode"
                 :hover="true"
                 :striped="true"
                 :bordered="false"
                 :small="true"
                 :per-page="perPage"
                 :current-page="currentPage"
                 :items="fleet.vessels"
                 :fields="fields">

          <template v-if="loading" #top-row>
            <b-td :colspan="fields.length">
              <div class="text-center">
                <i class="fa fa-2x fa-cog fa-spin text-muted m-2"></i>
              </div>
            </b-td>
          </template>

          <template #cell(delete)="cell">
            <i class="fa fa-lg fa-remove remove-vessel" @click="handleVesselDelete(cell)"/>
          </template>
        </b-table>
      </vue-perfect-scrollbar>

      <nav class="mt-2">
        <b-pagination :total-rows="fleet.vessels.length"
                      :per-page="perPage"
                      v-model="currentPage"
                      class="m-0"
                      prev-text="Prev"
                      next-text="Next"
                      hide-goto-end-buttons/>
      </nav>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import cloneDeep from 'lodash-es/cloneDeep';
import VuePerfectScrollbar from 'vue-perfect-scrollbar';

export default {
  name: 'fleet-vessel-table',
  components: {
    VuePerfectScrollbar,
  },

  props: {
    fleetId: {
      type: String,
      default: () => undefined,
    },
    fleets: {
      type: Array,
      default: () => [],
    },
    perPage: {
      type: Number,
      default: 5,
    },
    edit: {
      type: Boolean,
      default: false,
    },
    absoluteMode: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    let fields = [
      {
        key: 'imo',
        label: 'IMO',
      },
      {
        key: 'vesselName',
        label: 'Vessel Name',
      },
      {
        key: 'dwt',
        label: 'DWT',
      },
      {
        key: 'segment',
        label: 'Segment',
      },
      {
        key: 'type',
        label: 'Type',
      },
      {
        key: 'built',
        label: 'Built',
      },
    ];

    if(this.edit) {
      fields.push({
        key: 'delete',
        label: 'Delete',
        class: 'text-center',
      });
    }

    return {
      loading: true,
      fleet: {
        vessels: [],
      },
      fields: fields,
      currentPage: 1,
    }
  },

  async mounted() {
    await this.loadCurrentVessels();
  },

  methods: {
    ...mapActions('api/fleets', [
      'getFleet',
      'addVessel',
      'deleteVessel',
    ]),

    async handleVesselDelete(cell) {
      const vesselIMO = cell.item.imo;
      const vesselName = cell.item.vesselName;

      let modalResult = await this.$bvModal.msgBoxConfirm(
        `Are you sure you want to remove "${vesselName} (${vesselIMO})"?`,
        {
          title: 'Vessel removing confirmation',
          okVariant: 'danger',
          okTitle: 'YES',
          cancelTitle: 'Cancel',
          footerClass: 'p-2',
          hideHeaderClose: false,
          centered: false,
        },
      );

      if(modalResult) {
        // optimistic update
        // this.loading = true;
        this.fleet.vessels = this.fleet.vessels.filter(vessel => vessel.imo !== vesselIMO);

        // delete with api and refresh
        await this.deleteVessel({fleetId: this.fleetId, imo: vesselIMO});
        await this.loadCurrentVessels();
      }
    },

    async loadCurrentVessels() {
      this.fleet = await this.getFleet(this.fleetId);
      this.$emit('fleet-loaded', cloneDeep(this.fleet));
      this.loading = false;
    },
  },

  computed: {
    ...mapGetters('gui', [
      'darkMode',
    ]),
  },

  watch: {
    fleetId(value) {
      if(value) {
        this.loadCurrentVessels()
      }
    },
  },

}
</script>

<style lang="scss">
.custom-table {
  th, td {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>


<style scoped lang="scss">
.absolute-wrapper {
  position: absolute;
  height: 100%;
  width: 100%;

  .custom-table {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 10px;
    height: 100%;
    width: 100%;
  }
}

.remove-vessel {
  cursor: pointer;
  color: #a80000;

  &:hover {
    color: red;
  }
}
</style>
